import instantWinList from "./instantWinList.container";

export default instantWinList;